module.exports = __webpack_public_path__ + "img/compass.1d4ab080.svg";